import { useEffect, useState } from "react";
import Data from '@utils/BaseData';
import moment from 'moment';

export interface SiteConfigLink {
  icon: string,
  href: string,
  title: string,
  color: string,
  props: any
}

export interface ConfigOutput {
  logo: string,
  termite: {
    backgroundColor: string,
    color: string,
    emphasis: string,
  },
  docs: {
    root: string,
  },
  menu_background: string,
  menu_active: string,
  domain: string,
  banner: string,
  articles_path: string,
  links: Array<SiteConfigLink>,
  title: string,
  division: string,
  telephone: number,
  display_phone?: string,
}

const useSiteConfig = (): ConfigOutput | undefined => {

  const [config, setConfig] = useState<ConfigOutput | undefined>();

  useEffect(() => {
    Data.get('/site-config/config.json?' + moment().format('YYYYMMDDHHmm'), 'site').then((res: any) => {
      setConfig(res.body);
    })
  }, []);

  return config;

}

export default useSiteConfig;